import React, { useState } from 'react';
import { Row, Column, Button, Margin } from '@upgrade/react-components';
import Fluid from '../Fluid';
import { Heading } from '../common/TypographyPublicSite';
import Award from './award';

const AwardsSection = ({ title, awards }) => {
  const [showMoreAwards, setShowMoreAwards] = useState(false);

  if (!awards || awards.length === 0) return null;

  return (
    <Fluid key={title}>
      <Margin top="xl">
        <Heading as="h2" size="sm" align="center">
          {title}
        </Heading>
        <Margin top="xl" bottom="md">
          <Row gutter="large" xsHorizontalAlign="center" xsVerticalAlign="middle">
            {awards.slice(0, 4).map(award => (
              <Column xs={6} sm={3} key={award.url}>
                <Award {...{ ...award }} />
              </Column>
            ))}
            {showMoreAwards &&
              awards.slice(4).map(award => (
                <Column xs={6} sm={3} key={award.url}>
                  <Award {...{ ...award }} />
                </Column>
              ))}
          </Row>
        </Margin>
        {awards.length > 4 && (
          <Row xsHorizontalAlign="center">
            <Button
              emphasis="tertiary"
              onClick={() => setShowMoreAwards(prev => !prev)}
              buttonProps={{ 'aria-label': 'See more Awards and Recognitions' }}
            >
              {showMoreAwards ? 'See less' : 'See more'}
            </Button>
          </Row>
        )}
      </Margin>
    </Fluid>
  );
};

export default AwardsSection;
